
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { comForm } from "@newview/ui";
@Component({
  name: "nvLayout",
  components: {
    comForm
  },
})
export default class nvLayout extends BaseVue {
  @Prop({ default: "row" }) direction!: any;       //布局排布方向  row: 横向   column：垂直排列
  
  mounted() {
  }
}
